document.addEventListener("DOMContentLoaded", function () {
  initSubscriptionLogic();
  initVariantSelectors();
  initCustomAddToCart();

  document.querySelectorAll(".custom_variants").forEach((root) => {
    resolveVariant(root);
  });
});

function updateSupplyFrequency(recommendedBox) {
  if (!recommendedBox) return;
  
  let checkedPlan = recommendedBox.querySelector('.delivery-frequency input[type="radio"]:checked');
  if (!checkedPlan) {
    checkedPlan = recommendedBox.querySelector('.delivery-frequency input[type="radio"]');
  }
  if (!checkedPlan) return;

  const label = recommendedBox.querySelector(`label[for="${checkedPlan.id}"]`);
  if (!label) return;

  const frequencyText = label.textContent.trim();
  const frequencyMatch = frequencyText.match(/(\d+)/);
  if (!frequencyMatch) return;

  const frequencyDays = frequencyMatch[1];
  recommendedBox.querySelectorAll('.supply-frequency')?.forEach((element) => {
    element.textContent = `- ${frequencyDays} Days Supply`;
  });
}

function removeInitialUpsellState() {
  document.querySelectorAll(".recommended-box.gwp_upsell").forEach((box) => {
    box.classList.remove("gwp_upsell");
  });
}

function initSubscriptionLogic() {
  document.addEventListener("change", function (event) {
    const input = event.target;
    if (!input.matches('.delivery-frequency input[type="radio"]')) return;

    const recommendedBox = input.closest(".recommended-box");
    if (!recommendedBox) return;

    removeInitialUpsellState();
    if (!recommendedBox.classList.contains("active")) {
      const sellingKey = recommendedBox.dataset.selling;
      if (sellingKey) {
        activateSellingState(recommendedBox, sellingKey);
      }
    }

    handleSubscriptionSelection(input);
  });

  document.addEventListener("click", function (event) {
    if (event.target.closest(".delivery-frequency")) {
      return;
    }

    if (
      event.target.closest(".select-popout") ||
      event.target.closest("[data-popout-option]") ||
      event.target.closest("[data-popout-toggle]") ||
      event.target.closest("[data-single-option-selector]")
    ) {
      return;
    }

    const clickArea = event.target.closest(".ctm_recm_box__li");
    if (!clickArea) return;

    removeInitialUpsellState();

    const recommendedBox = clickArea.closest(".recommended-box");
    if (!recommendedBox) return;

    if(recommendedBox.classList.contains('gwp_upsell')){
      recommendedBox.classList.remove("gwp_upsell");
    }

    const frequencyItem = recommendedBox.querySelector(".data-frequency");
    const sellingKey = frequencyItem?.dataset.frequency || recommendedBox.dataset.selling;
    if (!sellingKey) return;

    if (recommendedBox.classList.contains("active")) {
      return;
    }

    activateSellingState(recommendedBox, sellingKey);
    if (sellingKey === "onetime") {
      syncSellingPlan(recommendedBox, sellingKey, "");
      return;
    }

    let selectedPlan = recommendedBox.querySelector('.delivery-frequency input[type="radio"]:checked');
    if (!selectedPlan) {
      selectedPlan = recommendedBox.querySelector('.delivery-frequency input[type="radio"]');
      if (selectedPlan) {
        selectedPlan.checked = true;
      }
    }
    if (!selectedPlan) return;

    syncSellingPlan(recommendedBox, sellingKey, selectedPlan.value);
    updateSupplyFrequency(recommendedBox);
  });

  document.addEventListener("click", function (event) {
    const label = event.target.closest(".delivery-frequency label");
    if (!label) return;

    removeInitialUpsellState();

    const recommendedBox = label.closest(".recommended-box");
    if (recommendedBox && !recommendedBox.classList.contains("active")) {
      const sellingKey = recommendedBox.dataset.selling;
      if (sellingKey) {
        activateSellingState(recommendedBox, sellingKey);
      }
    }

    event.stopPropagation();

    const inputId = label.getAttribute("for");
    if (!inputId) return;

    const input = document.getElementById(inputId);
    if (!input) return;

    input.checked = true;
    input.dispatchEvent(
      new Event("change", {
        bubbles: true,
      }),
    );
  });
}

function handleSubscriptionSelection(input) {
  const recommendedBox = input.closest(".recommended-box");
  if (!recommendedBox) return;

  const radioGroup = recommendedBox.querySelectorAll('.delivery-frequency input[type="radio"]');
  radioGroup.forEach((radio) => {
    radio.checked = false;
  });

  input.checked = true;
  const sellingKey = recommendedBox.dataset.selling;
  syncSellingPlan(recommendedBox, sellingKey, input.value);
  updateSupplyFrequency(recommendedBox);
  const productContainer = recommendedBox.closest(".product") || document;
  let activeRoot = null;

  if (sellingKey === "onetime" || sellingKey.match(/subscription-1-/)) {
    activeRoot = productContainer.querySelector(".custom_variants.default_options.active");
  } else {
    activeRoot = productContainer.querySelector(`.custom_variants[data-type="${sellingKey}"].active`);
  }
  if (!activeRoot) return;

  resolveVariant(activeRoot);
}

function activateSellingState(recommendedBox, sellingKey) {
  const productContainer = recommendedBox.closest(".product") || document;
  productContainer.querySelectorAll(".recommended-box").forEach((box) => {
    box.classList.remove("active");
  });

  productContainer.querySelectorAll(".data-frequency").forEach((item) => {
    item.classList.remove("active");
  });

  productContainer.querySelectorAll(".subscription_variants").forEach((wrapper) => {
    wrapper.classList.remove("active");
  });

  productContainer.querySelectorAll(".custom_variants").forEach((variant) => {
    variant.classList.remove("active");
  });

  recommendedBox.classList.add("active");
  const activeFrequency = recommendedBox.querySelector(`.data-frequency[data-frequency="${sellingKey}"]`);
  if (activeFrequency) {
    activeFrequency.classList.add("active");
  }

  const isSubscription = sellingKey !== "onetime";
  let quantity = 1;
  if (isSubscription) {
    const quantityMatch = sellingKey.match(/subscription-(\d+)-/);
    if (quantityMatch) {
      quantity = parseInt(quantityMatch[1]);
    }
  }

  const quantitySelector = productContainer.querySelector(".product-form__quantity");
  if (quantitySelector) {
    if (isSubscription) {
      quantitySelector.style.display = "none";
    } else {
      quantitySelector.style.display = "";
    }
  }

  let targetVariantRoot = null;
  if (sellingKey === "onetime" || quantity === 1) {
    targetVariantRoot = productContainer.querySelector(".custom_variants.default_options");
  } else {
    targetVariantRoot = productContainer.querySelector(`.custom_variants[data-type="${sellingKey}"]`);
    const subscriptionWrapper = targetVariantRoot?.closest(".subscription_variants");
    if (subscriptionWrapper) {
      subscriptionWrapper.classList.add("active");
    }
  }
  if (!targetVariantRoot) return;

  targetVariantRoot.classList.add("active");
  resolveVariant(targetVariantRoot);
}

function syncSellingPlan(recommendedBox, sellingKey, sellingPlanId) {
  const productContainer = recommendedBox.closest(".product") || document;
  const form = productContainer.querySelector("form[data-product-form]");
  if (!form) return;

  let sellingInput = form.querySelector('input[name="selling_plan"]');
  if (!sellingInput) {
    sellingInput = document.createElement("input");
    sellingInput.type = "hidden";
    sellingInput.name = "selling_plan";
    form.appendChild(sellingInput);
  }

  if (sellingKey === "onetime") {
    sellingInput.value = "";
    return;
  }

  sellingInput.value = sellingPlanId;
  sellingInput.dispatchEvent(
    new Event("change", {
      bubbles: true,
    }),
  );
}

function initVariantSelectors() {
  document.addEventListener("click", function (event) {
    const dropdownOption = event.target.closest("[data-popout-option]");
    if (dropdownOption) {
      event.preventDefault();
      handleDropdown(dropdownOption);
      return;
    }

    const radio = event.target.closest("[data-single-option-selector]");
    if (radio) {
      const root = radio.closest(".custom_variants");
      if (!root) return;

      updateLegend(radio);
      resolveVariant(root);
      return;
    }

    const toggle = event.target.closest("[data-popout-toggle]");
    if (toggle) {
      event.preventDefault();

      const popout = toggle.closest(".select-popout");
      const list = popout.querySelector("[data-popout-list]");

      document.querySelectorAll("[data-popout-list]").forEach((dropdown) => {
        if (dropdown !== list) {
          dropdown.classList.remove("popout-list--visible");
        }
      });

      list.classList.toggle("popout-list--visible");
    }
  });

  document.addEventListener("change", function (event) {
    const input = event.target;
    if (input.matches("[data-single-option-selector]")) {
      const root = input.closest(".custom_variants");
      if (!root) return;

      resolveVariant(root);
    }
  });

  document.addEventListener("click", function(event) {
    const clickedInsidePopout = event.target.closest(".select-popout");

    if (clickedInsidePopout) {
      return;
    }

    document.querySelectorAll("[data-popout-list]").forEach((list) => {
      list.classList.remove("popout-list--visible");
    });
  });
}

function handleDropdown(option) {
  const popout = option.closest(".select-popout");
  const value = option.dataset.value;
  const input = popout.querySelector("[data-popout-input]");
  const toggleText = popout.querySelector("[data-popout-toggle-text]");
  const color = option?.dataset.swatchColor || "#ccc";
  const legend = popout.querySelector("[data-selected-swatch]");
  if (legend) {
    legend.style.setProperty("--swatch", color);
  }
  if (toggleText) {
    toggleText.textContent = value;
  }

  if (input) {
    input.value = value;
    input.dispatchEvent(
      new Event("change", {
        bubbles: true,
      }),
    );
  }

  popout.querySelectorAll(".select-popout__item").forEach((item) => {
    item.classList.remove("is-active");
  });

  option.closest(".select-popout__item")?.classList.add("is-active");
  popout.querySelector("[data-popout-list]")?.classList.remove("popout-list--visible");
}

function updateLegend(input) {
  const wrapper = input.closest(".selector-wrapper");
  if (!wrapper) return;

  const legend = wrapper.querySelector("[data-option-value]");
  if (legend) {
    legend.textContent = input.value;
  }
}

function resolveVariant(root) {
  const selectedOptions = [];
  root.querySelectorAll("[data-single-option-selector]").forEach((input) => {
    if (input.type === "radio") {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    } else {
      selectedOptions.push(input.value);
    }
  });

  const variantsScript = document.querySelector('noscript[for="product-variants"]');
  if (!variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent.trim());
  } catch (e) {
    return;
  }

  const matchedVariant = variants.find((variant) => {
    return variant.options.every((opt, index) => {
      return opt === selectedOptions[index];
    });
  });
  if (!matchedVariant) return;

  root.dataset.variantId = matchedVariant.id;
}

function initCustomAddToCart() {
  document.querySelectorAll(".form__width:has(.subscription_n_save) form[data-product-form]").forEach((form) => {
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      return false;
    }, true);
  });


  document.addEventListener("click", async function (event) {
    let button = null;
    if(event.target.closest(".product")){
      button = event.target.closest(".form__width:has(.subscription_n_save) .product-form__quantity[style='display: none;'] + [data-add-to-cart]");
    } else {
      button = event.target.closest(".form__width:has(.subscription_n_save) [data-add-to-cart]");
    }
    if (!button) return;
    
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    
    const form = button.closest("form[data-product-form]");
    if (!form) {
      console.log("No form");
      return;
    }

    button.classList.add("is-loading");

    const productContainer = form.closest(".product") || document;
    const activeBox = productContainer.querySelector(".recommended-box.active");
    if (!activeBox) {
      console.log("No active recommended box");
      return;
    }

    const sellingKey = activeBox.dataset.selling;
    let activeRoot = null;
    if (sellingKey === "onetime" || sellingKey.match(/subscription-1-/)) {
      activeRoot = productContainer.querySelector(".custom_variants.default_options.active");
    } else {
      activeRoot = productContainer.querySelector(`.custom_variants[data-type="${sellingKey}"].active`);
    }
    if (!activeRoot) {
      console.log("No active variant root");
      return;
    }
    console.log("Active variant root found");

    resolveVariant(activeRoot);
    let variantId = activeRoot.dataset.variantId;
    if (!variantId) {
      variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) {
        console.log("No variant ID");
        return;
      }
    }
    console.log("Variant ID:", variantId);

    if (sellingKey === "onetime") {
      const quantityInput = form.querySelector('input[name="quantity"]');
      let quantity = 1;
      if (quantityInput) {
        quantity = parseInt(quantityInput.value);
      }

      const payload = {
        items: [
          {
            id: parseInt(variantId),
            quantity: quantity,
          },
        ],
      };
      console.log("Adding to cart:", payload);

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();
        button.classList.remove("is-loading");
        button.classList.add("is-added");
        setTimeout(() => {
          button.classList.remove("is-added");
        }, 2000);

        document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
      } catch (error) {
        console.error(error);
      }

      return;
    }

    let quantity = 1;
    const quantityMatch = sellingKey.match(/subscription-(\d+)-/);
    if (quantityMatch) {
      quantity = parseInt(quantityMatch[1]);
    }

    const checkedPlan = activeBox.querySelector('.delivery-frequency input[type="radio"]:checked');
    if (!checkedPlan) {
      console.log("No checked selling plan");
      return;
    }

    const sellingPlan = checkedPlan.value;
    const items = [];
    if (sellingKey.match(/subscription-1-/)) {
      items.push({
        id: parseInt(variantId),
        quantity: 1,
        selling_plan: parseInt(sellingPlan),
      });
    } else {
      const tubSelectors = activeRoot.querySelectorAll(".selector-wrapper[data-pack-number]");
      const variantsScript = document.querySelector('noscript[for="product-variants"]');
      if (!variantsScript) {
        console.log("No variants JSON");
        return;
      }

      let variants = [];
      try {
        variants = JSON.parse(variantsScript.textContent.trim());
      } catch (e) {
        console.log("Variant parse error");
        return;
      }

      if(variants.length > 1){
        tubSelectors.forEach((selector, index) => {
          const optionInput = selector.querySelector("[data-popout-input]");
          if (!optionInput) {
            console.log("No option input for tub", index + 1);
            return;
          }

          const selectedValue = optionInput.value;
          const matchedVariant = variants.find((variant) => {
            return variant.option1 === selectedValue;
          });

          if (!matchedVariant) {
            console.log("No variant found:", selectedValue);
            return;
          }

          items.push({
            id: parseInt(matchedVariant.id),
            quantity: 1,
            selling_plan: parseInt(sellingPlan),
          });
        });
      } else {
        items.push({
          id: parseInt(variantId),
          quantity: quantity,
          selling_plan: parseInt(sellingPlan),
        });
      }
    }

    const payload = {
      items: items,
    };

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      button.classList.remove("is-loading");
      button.classList.add("is-added");
      setTimeout(() => {
        button.classList.remove("is-added");
      }, 2000);

      document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
    } catch (error) {
      console.error(error);
    }
  }, true);
}

window.addEventListener("load", function () {
  const activeFrequency = document.querySelector(".data-frequency.active");
  if (!activeFrequency) return;

  const recommendedBox = activeFrequency.closest(".recommended-box");
  if (!recommendedBox) return;

  const sellingKey = activeFrequency.dataset.frequency;
  activateSellingState(recommendedBox, sellingKey);
  document.querySelectorAll('.recommended-box').forEach((box) => {
    updateSupplyFrequency(box);
  });
});